export default __webpack_public_path__ + "static/media/Blooded Legguards of the Plains.9ee69316.jpg";